/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useEdition } from '../../contexts/EditionContext';
import CircledPlusIcon from '../icons/CircledPlus';
import WatchIcon from '../icons/Watch';
import CardButtons from '../partials/CardButtons';
import CardLayout from '../partials/CardLayout';
import Date from '../partials/Date';
import DateRange from '../partials/DateRange';
import IconLink from '../partials/IconLink';

import styles from '../../../styles/cards/purchase.module.scss';

const propTypes = {
    item: AppPropTypes.listItem,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    className: null,
};

const PurchaseCard = ({ item, className }) => {
    const { amount = null, date = null, item: purchasedItem = null, product = null } = item;
    const {
        name = null,
        // type: itemType = null,
        film = null,
        event = null,
        title = null,
        image = null,
        startDate = null,
        endDate = null,
        isOnline = null,
        isUpcoming = null,
    } = purchasedItem || {};
    const { url: imageUrl = null } = image || {};
    const { url: eventUrl = null } = event || {};
    const { url: filmUrl = null } = film || {};
    const {
        url: productUrl = null,
        name: productName = null,
        type: productType = null,
        isBundle: isProductBundle = false,
    } = product || {};

    const { tickets = [] } = useEdition();
    const ticket = tickets.find((it) => it.type === productType) || null;
    const { name: ticketName = null } = ticket || {};

    const isForum = productType === 'forum';
    // const isScreening = itemType === 'screening';
    const isBundle = productType === 'shift72' && isProductBundle;
    const productCardTitle = isBundle || isForum ? productName : title;
    const showVisual = !isBundle && image !== null && imageUrl !== null;
    const finalTitle = productCardTitle || name || ticketName || title;
    return (
        <CardLayout
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            isWide
            image={showVisual ? image : null}
            buttons={
                <CardButtons>
                    {productType === 'shift72' && productUrl !== null ? (
                        <IconLink
                            className={styles.actionButton}
                            icon={<WatchIcon />}
                            href={productUrl}
                            external
                        >
                            <FormattedMessage
                                defaultMessage="Watch online"
                                description="Button label"
                            />
                        </IconLink>
                    ) : null}

                    {productType === 'forum' && productUrl !== null ? (
                        <IconLink
                            className={styles.actionButton}
                            icon={<CircledPlusIcon />}
                            href={productUrl}
                        >
                            <FormattedMessage
                                defaultMessage="Access forum page"
                                description="Button label"
                            />
                        </IconLink>
                    ) : null}

                    {filmUrl !== null && !isBundle ? (
                        <IconLink
                            className={styles.actionButton}
                            icon={<CircledPlusIcon />}
                            href={filmUrl}
                            secondary
                        >
                            <FormattedMessage
                                defaultMessage="View film page"
                                description="Button label"
                            />
                        </IconLink>
                    ) : null}

                    {eventUrl !== null ? (
                        <IconLink
                            className={styles.actionButton}
                            icon={<CircledPlusIcon />}
                            href={eventUrl}
                            secondary
                        >
                            <FormattedMessage
                                defaultMessage="View event page"
                                description="Button label"
                            />
                        </IconLink>
                    ) : null}
                </CardButtons>
            }
        >
            <div className={styles.content}>
                <h2 className={styles.title}>{finalTitle}</h2>

                {startDate !== null && endDate !== null && !isForum ? (
                    <DateRange
                        startDate={startDate}
                        endDate={endDate}
                        startPrefix={
                            <FormattedMessage defaultMessage="From:" description="Date prefix" />
                        }
                        endPrefix={
                            <FormattedMessage defaultMessage="Until:" description="Date prefix" />
                        }
                        className={styles.purchaseInfo}
                    />
                ) : null}

                {startDate !== null && endDate === null && !isForum ? (
                    <div className={styles.purchaseInfo}>
                        {isOnline && isUpcoming ? (
                            <div className={styles.label}>
                                <FormattedMessage
                                    defaultMessage="Available from:"
                                    description="Date prefix"
                                />
                            </div>
                        ) : null}
                        <Date date={startDate} className={styles.purchaseInfo} />
                    </div>
                ) : null}

                <div className={styles.purchaseInfo}>
                    <div className={styles.label}>
                        <FormattedMessage
                            defaultMessage="Purchased:"
                            description="Event card info"
                        />
                    </div>
                    <Date date={date} />
                </div>

                {amount !== null ? (
                    <div className={styles.purchaseInfo}>
                        <div className={styles.label}>
                            <FormattedMessage defaultMessage="Price:" description="Button label" />
                        </div>
                        {amount}
                    </div>
                ) : null}
            </div>
        </CardLayout>
    );
};

PurchaseCard.propTypes = propTypes;
PurchaseCard.defaultProps = defaultProps;

export default PurchaseCard;
